import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { needsOnboarding } from "./onboarding";
import type { UserType } from "./types";

const ROUTE_BY_TYPE: Record<UserType, string> = {
  admin_global: "/admin",
  admin_federacao: "/federacao",
  usuario_clube: "/clube",
  responsavel: "/responsavel",
  atleta: "/atleta",
  oficial: "/oficial",
};

/**
 * Redirect pós-login automático (briefing seção 10.3).
 */
export function RoleRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (needsOnboarding(user)) return <Navigate to="/primeiro-acesso" replace />;
  return <Navigate to={ROUTE_BY_TYPE[user.tipo]} replace />;
}
